import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  setCalenderBargiryShow,
  setCalenderTakhliehShow,
  setLoadDescBargiry,
  setLoadDescTakhlie,
  setTakhliehTimeShow,
} from "../../redux/newRequest/newRequest.actions";
import {
  selectNewRequestCalenderBargiry_show,
  selectNewRequestCalenderTakhlieh_show,
  selectNewRequestDescBargiry,
  selectNewRequestDescTakhlieh,
  selectNewRequestBargiryTime,
  selectNewRequestTakhliehTimeShow,
  selectNewRequestBargiryDate,
  selectNewRequestTakhliehTime,
  selectNewRequestTakhliehDate,
} from "../../redux/newRequest/newRequest.selectors";
import BargiryTimeInputs from "../bargiryTimeInputs/BargiryTimeInputs.component";
import { LoadTimingStyled } from "./loadTiming.styles";

import TakhliehTimeInputs from "../takhliehTimeInputs/TakhliehTimeInputs.component";

const LoadTiming = ({
  LoadTiming,

  setLoadDescTakhlie,
  setLoadDescBargiry,
  selectNewRequestDescTakhlieh,
  selectNewRequestDescBargiry,

  setCalenderBargiryShow,
  setCalenderTakhliehShow,
  selectNewRequestCalenderTakhlieh_show,
  selectNewRequestCalenderBargiry_show,
  selectNewRequestTakhliehTimeShow,

  selectNewRequestBargiryTime,
  selectNewRequestBargiryDate,

  selectNewRequestTakhliehDate,
  selectNewRequestTakhliehTime,

  setTakhliehTimeShow,
}) => {
  //   debugger;
  const handle_descTakh_change = (e) => {
    const value = e.currentTarget.value;
    setLoadDescTakhlie(value);
  };
  const handle_descBarg_change = (e) => {
    const value = e.currentTarget.value;
    setLoadDescBargiry(value);

    // alert("hi");
  };

  const handle_calenderBargiry_click = () => {
    // alert("hi");

    setCalenderBargiryShow(true);
  };

  const handle_calenderTakhlieh_click = () => {
    // alert("hi");
    // setCalenderTakhliehShow(true);
    setTakhliehTimeShow(true);
  };

  return (
    <LoadTimingStyled>
      <div>
        <div
          onClick={handle_calenderBargiry_click}
          className="btn--colored btn--colored-blue"
        >
          <div className="btn--colored__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
            >
              <g id="Group_1124" transform="translate(-207 -99)">
                <g
                  id="Rectangle_1923"
                  fill="none"
                  stroke="#fff"
                  transform="translate(207 99)"
                >
                  <rect width="12" height="12" stroke="none" rx="4" />
                  <rect width="11" height="11" x=".5" y=".5" rx="3.5" />
                </g>
                <path 
                  id="Line_38"
                  d="M0 4L0 0"
                  className="cls-2"
                  transform="translate(213 101)"
                  stroke="white"
                />
                <path
                  id="Line_39"
                  d="M0 0L2.5 1.5"
                  className="cls-2"
                  transform="translate(213 105)"
                  stroke="white"
                />
              </g>
            </svg>
          </div>
          <div>زمان‌بندی بارگیری</div>
        </div>
        {selectNewRequestBargiryTime || selectNewRequestBargiryDate ? (
          <BargiryTimeInputs />
        ) : null}
        <div>
          <textarea
            onChange={(e) => handle_descBarg_change(e)}
            placeholder="توضیحات بارگیری"
            name=""
            id=""
            cols="30"
            rows="2"
            className="text-area"
            value={selectNewRequestDescBargiry}
          ></textarea>
        </div>
      </div>
      <div className="mt-3">
        <div
          className="btn--colored btn--colored-green"
          onClick={handle_calenderTakhlieh_click}
        >
          <div className="btn--colored__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
            >
              {/* <defs>
        <style>
            .cls-2{fill:none;stroke:#fff;strokeLinecap:round}
        </style>
    </defs> */}
              <g id="Group_1124" transform="translate(-207 -99)">
                <g
                  id="Rectangle_1923"
                  fill="none"
                  stroke="#fff"
                  transform="translate(207 99)"
                >
                  <rect width="12" height="12" stroke="none" rx="4" />
                  <rect width="11" height="11" x=".5" y=".5" rx="3.5" />
                </g>
                <path
                  id="Line_38"
                  d="M0 4L0 0"
                  className="cls-2"
                  transform="translate(213 101)"
                  stroke="white"
                />
                <path
                  id="Line_39"
                  d="M0 0L2.5 1.5"
                  className="cls-2"
                  transform="translate(213 105)"
                  stroke="white"
                />
              </g>
            </svg>
          </div>
          <div>زمان‌بندی تخلیه</div>
        </div>
        {selectNewRequestTakhliehTimeShow ? <TakhliehTimeInputs /> : null}
        <div>
          <textarea
            onChange={(e) => handle_descTakh_change(e)}
            placeholder="توضیحات تخلیه"
            name=""
            id=""
            cols="30"
            rows="2"
            className="text-area"
            value={selectNewRequestDescTakhlieh}
          ></textarea>
        </div>
      </div>
    </LoadTimingStyled>
  );
};

const mapStateToProps = createStructuredSelector({
  selectNewRequestDescTakhlieh: selectNewRequestDescTakhlieh,
  selectNewRequestDescBargiry: selectNewRequestDescBargiry,

  selectNewRequestCalenderBargiry_show: selectNewRequestCalenderBargiry_show,
  selectNewRequestCalenderTakhlieh_show: selectNewRequestCalenderTakhlieh_show,

  selectNewRequestBargiryDate: selectNewRequestBargiryDate,
  selectNewRequestBargiryTime: selectNewRequestBargiryTime,

  selectNewRequestTakhliehDate: selectNewRequestTakhliehDate,
  selectNewRequestTakhliehTime: selectNewRequestTakhliehTime,

  selectNewRequestTakhliehTimeShow: selectNewRequestTakhliehTimeShow,
});

const mapDispatchToProps = (dispatch) => ({
  setLoadDescTakhlie: (x) => dispatch(setLoadDescTakhlie(x)),
  setLoadDescBargiry: (x) => dispatch(setLoadDescBargiry(x)),

  setCalenderBargiryShow: (x) => dispatch(setCalenderBargiryShow(x)),
  setCalenderTakhliehShow: (x) => dispatch(setCalenderTakhliehShow(x)),

  setTakhliehTimeShow: (x) => dispatch(setTakhliehTimeShow(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoadTiming);
